"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationUuid = void 0;
var ApplicationUuid;
(function (ApplicationUuid) {
    ApplicationUuid["AutoAssign"] = "7083ab3d-c7de-40fd-83bb-f2c10bd0fa88";
    ApplicationUuid["AAA"] = "3ecfa3f6-1a21-11e8-accf-0ed5f89f718b";
    ApplicationUuid["CustomAttributeApplication"] = "eb377388-08b9-48e2-9752-5066b4446d50";
    ApplicationUuid["ActOnTriggerApp"] = "8ebe8358-62d3-11ea-bc55-0242ac130003";
    ApplicationUuid["AutoBreaks"] = "9310325e-d7d5-11ea-87d0-0242ac130003";
    ApplicationUuid["AvailableDrivers"] = "17fea9d6-9f5e-4234-91b4-34d6677ba5be";
    ApplicationUuid["Bitly"] = "f4b3ade5-4997-418e-8f99-1813dd1e56df";
    ApplicationUuid["BackToWarehouse"] = "d21a5684-8997-11e8-9a94-a6cf71072f73";
    ApplicationUuid["Boulanger"] = "34dc733d-7d17-4e44-8884-bb1ec1197da6";
    ApplicationUuid["Clover"] = "7661994f-da60-4f5d-bda9-4c132fb19484";
    ApplicationUuid["CocaCola"] = "eaf03283-dce4-4567-b6bf-f3eb3573357e";
    ApplicationUuid["CancellationTasks"] = "94c67d35-e289-44de-a19d-8ee0b02b00e0";
    ApplicationUuid["Chat"] = "6ee9296a-38bd-4d8e-81c6-b16001a20ee3";
    ApplicationUuid["CocaColaBrazilApp"] = "f9bd58a4-a514-11ea-bb37-0242ac130002";
    ApplicationUuid["CocaColaChile"] = "075c7b23-a847-4510-bc86-79fd0d5be557";
    ApplicationUuid["ComingHomeApp"] = "c7d80d71-fe64-43b1-9d66-c8a76db31ea5";
    ApplicationUuid["Conduit"] = "1294eec3-550d-4d71-8831-d9051750742a";
    ApplicationUuid["CoopApp"] = "6b88b9d4-d79a-4d62-8ded-fa0e5c7d67be";
    ApplicationUuid["CustomerExperienceApp"] = "caf4e836-e507-4f68-bb9c-c4511bb69750";
    ApplicationUuid["CustomerExperienceWebApp"] = "a4338daf-babe-4fc4-a2d4-9050da8c1782";
    ApplicationUuid["DataTrac"] = "d07f52b1-bf43-400f-88ab-40426de4b17c";
    ApplicationUuid["DetectDriverOffRoute"] = "dd2ad97a-ffee-11e5-86aa-5e5517507c66";
    ApplicationUuid["DHL"] = "ec424a40-a9b9-11e6-80f5-76304dec7eb7";
    ApplicationUuid["DispatcherNotifier"] = "f574941d-fd43-4c4e-bd85-9b4107e569f3";
    ApplicationUuid["DriverActivityVerifier"] = "f68bae82-dac7-411c-a772-792226bc8ea4";
    ApplicationUuid["DriverPayments"] = "88260a80-c003-4d66-bf81-5f15443286ed";
    ApplicationUuid["ETA"] = "9369f5d4-57d8-4806-b2c9-fcc6f4e51531";
    ApplicationUuid["ExternalFleetApp"] = "271c52e5-0a1a-40cb-9f24-730ec91e4afc";
    ApplicationUuid["FailedDeliveryManager"] = "de7f883b-bab4-4e25-a830-83bd1c5cb270";
    ApplicationUuid["FedexFreight"] = "064844ab-e6f4-4b0e-8e26-383a408cab2a";
    ApplicationUuid["FleetRouterApp"] = "0ee6e692-3948-4346-b57c-671d3c8b7237";
    ApplicationUuid["FloatingInventoryApp"] = "d7409473-fc0b-4d1e-a085-04634f5acd4f";
    ApplicationUuid["GeocodingFiltering"] = "afc79118-6409-43f5-94aa-268dd3d98539";
    ApplicationUuid["HoursStats"] = "88b80320-7587-447c-88bf-04e12737aebc";
    ApplicationUuid["Integration"] = "2a4c90a3-b433-40f5-88bc-d4e9020197dc";
    ApplicationUuid["KFC"] = "9250b181-92c1-4a3d-8934-8fdb6c791567";
    ApplicationUuid["LeroyMerlinIntegrationApp"] = "45c6821b-a645-424c-9bb6-9564f1f1d19f";
    ApplicationUuid["LastLocationEstimator"] = "325328e0-9347-11e5-abc1-69640172f3ad";
    ApplicationUuid["ManagerAuthorizationRules"] = "2a634eb8-145a-4269-978c-515878beda80";
    ApplicationUuid["MiddleMile"] = "13b785c1-5814-49b5-956a-b6f068161f41";
    ApplicationUuid["Nextel"] = "a91c3e27-ed17-4d0b-9c46-5981cd2cd09c";
    ApplicationUuid["OAuth"] = "811570c1-3e34-4b55-884a-6500dd50d310";
    ApplicationUuid["Panera"] = "7e0b2c26-cfa2-4106-b4d6-c9aa3adc5478";
    ApplicationUuid["ParcelShop"] = "cd854cf7-0342-45e1-8212-dee71f599951";
    ApplicationUuid["Pickup"] = "3b62707b-22ad-4601-bef9-804927d6ca9f";
    ApplicationUuid["PlannedEtaApp"] = "e5a10347-ed56-44f4-8613-fe17f94a077f";
    ApplicationUuid["Preparation"] = "515a459e-bba3-4a52-889e-54b5b967cbf9";
    ApplicationUuid["QuotesApp"] = "c43a6eaa-dd2a-4d88-a339-861686546f08";
    ApplicationUuid["RapidSosApp"] = "76d2338f-6da3-412b-815b-b0e90d862b86";
    ApplicationUuid["RDS"] = "5ba318c1-aa07-448b-a25d-3a42e1e70ef0";
    ApplicationUuid["RealtimeEtaApp"] = "2fd6d6c6-f4b4-4b85-854c-4ee193512899";
    ApplicationUuid["RouteOptimizer2"] = "9dd3a937-b51e-41ed-afb4-6c3d97cdd620";
    ApplicationUuid["ShareLocation"] = "f8b6d7e6-bbeb-4468-be51-fb012d001fe3";
    ApplicationUuid["SuperAdmin"] = "2b8d33ba-41dc-4db5-bf42-791cd340154e";
    ApplicationUuid["ShareLocationOnUpdate"] = "b9c4b248-c517-11e9-aa8c-2a2ae2dbcce4";
    ApplicationUuid["Shell"] = "7167224f-1689-44eb-a615-ca2935e71b83";
    ApplicationUuid["Shopify"] = "2c376813-6647-498f-b53f-a53352ba02d7";
    ApplicationUuid["SingleSignOn"] = "ec763a46-8ad7-48d8-aab7-dcefcb794ff9";
    ApplicationUuid["SmsDriverNotifier"] = "cbd475f3-a88b-45cb-aaf5-4d9bbe2c2f0b";
    ApplicationUuid["StoreAppApp"] = "b4152c59-70a3-415e-b414-ce419550782e";
    ApplicationUuid["TowNow"] = "cd52a2c2-193d-4f92-bf01-3412194e18b2";
    ApplicationUuid["TasksETL"] = "3043914f-9be6-43c6-b1d8-e249410c79bc";
    ApplicationUuid["TaskSchedulingApp"] = "779d22c8-e18a-4723-9fd9-b5475178c244";
    ApplicationUuid["TaskSkillsApp"] = "b6dbfed4-d416-48eb-9552-610b15ff5748";
    ApplicationUuid["TaskTimesPredictions"] = "6c573459-dad9-4486-bdaa-b7ff32bd3019";
    ApplicationUuid["TaskValidation"] = "56ca6350-b2bf-11e9-a2a3-2a2ae2dbcce4";
    ApplicationUuid["TimeBasedTrigger"] = "fa7399cd-745a-47b5-ba3d-34c3fa4c03ad";
    ApplicationUuid["UserRoleSkills"] = "f917dda7-806e-4d2c-bb07-47039375e4ec";
    ApplicationUuid["UpsIntegration"] = "b8cc8bb2-78be-11ea-bc55-0242ac130003";
    ApplicationUuid["VrpAutoDispatch"] = "da0db19e-5836-4750-959e-4689fb78a82c";
    ApplicationUuid["Wizard"] = "d1c9bbe8-ec15-11e4-adf3-1681e6b88ec1";
    ApplicationUuid["Walmart"] = "f9b14523-4a9a-4baf-b97e-2b9d9f3e913a";
    ApplicationUuid["Webhooks"] = "5920d1a0-4c82-11e4-916c-0800200c9a66";
    ApplicationUuid["WebhookTimeZone"] = "d3b976db-a8cf-4930-9489-b13d21075180";
    ApplicationUuid["WebhookApp"] = "52228df2-2759-432d-8865-2593d2ba6c12";
    ApplicationUuid["EventBasedActions"] = "56cc30b4-1600-42ca-ba58-94220961f110";
    ApplicationUuid["InventoryTriggeredActions"] = "bef201bc-f003-4ee5-9780-a03cb6951d3d";
    ApplicationUuid["RuleEngine"] = "e6d7c261-9d8d-4042-bd1e-5355cc5a348a";
    ApplicationUuid["Recurrences"] = "707e4ead-ac57-489d-8dd3-fcb5b14aae5d";
    ApplicationUuid["TaskService"] = "5ca4a73e-5298-4b8a-a36f-d1cc76e20f49";
    ApplicationUuid["ExclusionWindowTasksLimitApp"] = "376233f1-8be5-4366-9218-6d66e7a8d2de";
    ApplicationUuid["Availability"] = "2c6bf985-414b-4411-888a-c0840e660411";
    ApplicationUuid["TaskManagedAttributes"] = "d50d31d3-282e-4fb1-a17b-050e5b531650";
})(ApplicationUuid || (exports.ApplicationUuid = ApplicationUuid = {}));
//# sourceMappingURL=application.js.map